/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ManageProjectTabs {
  General,
  Clusters,
  Members,
}

export const tabToRouteBinding = {
  [ManageProjectTabs.General]: '',
  [ManageProjectTabs.Clusters]: 'clusters',
  [ManageProjectTabs.Members]: 'members',
};
